import wrapperHOC from "@Utils/wrapperHOC";
import styles from "./NoResultsCard.module.scss";
import Image from "@Components/Image";
import { BASE_IMG_URL } from "constants/configConstants";
import CustomLink from "@Components/CustomLink";
import useTranslationHook from "hooks/useTranslationHook";

interface NoResultsCardProps {
  searchQuery: string;
  basePath: string;
  contentLabel: string;
}

const NoResultsCard = ({ searchQuery, basePath, contentLabel }: NoResultsCardProps) => {
  const { t } = useTranslationHook();
  return (
    <div className={styles.noResultsContainer}>
      <Image
        src={`${BASE_IMG_URL}no_results_icon.svg`}
        alt={t("blog.grid.noresults.alt")}
        height={120}
        width={120}
      />
      <h2 className={styles.title}>{t("blog.grid.noresults.title", { contentLabel })}</h2>
      <p className={styles.description}>
        {t("blog.grid.noresults.description", { contentLabel: contentLabel.toLowerCase() })} &quot;
        {searchQuery}&quot;. {t("blog.grid.noresults.suggestion")}{" "}
        <CustomLink href={basePath} className={styles.link}>
          {t("blog.grid.noresults.latestlink")} {contentLabel.toLowerCase()}
        </CustomLink>
        .
      </p>
    </div>
  );
};

export default wrapperHOC(NoResultsCard, {
  componentName: "NoResultsCard",
  showForChina: true,
});
